import axios from "../utils/axios";

export const login = async (payload) => {
  const response = await axios.post("/auth", payload);
  return response;
};

export const verifyPluginLogin = async (sso) => {
  const response = await axios.get("/auth/plugin-user", {
    headers: {
      Authorization: `Bearer `+sso,
    },
  });
  return response;
};

export const authUser = async () => {
  const response = await axios.get("/users", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const logout = async () => {
  const response = await axios.get("/auth/logout", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const forgetPasswordAfterLogin = async (payload) => {
  const response = await axios.put("/auth/forget-password", payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const authenticateGoogle = async (code, params=null) => {
  try {
    const response = await axios.get('/auth/authorize-google-token', {
      params: {
        code,
        ...params
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getGoogleAuthUrl = async (type = null, params = {}) => {
  try {
    const config = { params: {} };

    if (type) config.params.type = type;
    if (params && typeof params === 'object') Object.assign(config.params, params);

    const response = await axios.get(`/auth/get-google-auth-url`, config);

    return response;
  } catch (error) {
    return error;
  }
};

export const forgetPasswordBeforeLogin = async (payload) => {
  const response = await axios.post("/auth/send-mail", payload);
  return response;
};

export const verifyToken = async (payload) => {
  const response = await axios.post("/auth/verify-mail-token", payload);
  return response;
};

export const resetPassword = async (payload) => {
  const response = await axios.post("/auth/reset-password", payload);
  return response;
};
export const register = async (payload) => {
  try {
    const response = await axios.post(`/auth/register`, payload);
    return response.data;
  } catch (error) {
    console.error("Error registering:", error);
    throw error;
  }
};


export const confirmToken = async (token) => {
  try {
    const response = await axios.get(`/auth/email/confirmation`, {
      params: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error confirming token:", error);
    throw error;
  }
};

export const authorizeGoogleRefreshToken = async (code, type = null) => {
    try {
      const config = {};

      if (type) {
        config.params = {
          type: type,
        };
      }

      const response = await axios.get(
        `/auth/authorize-google-refresh-token?code=${code}`,
        config
      );

      return response;
    } catch (error) {
      throw error;
    }
  
};

export const authenticateGoogleOneTap = async (credential, { termsAndConditions, dataProtection, marketingPurpose } = {}) => {
  try {
    const payload = { credential };
    if (termsAndConditions !== undefined) {
      payload.termsAndConditions = termsAndConditions;
      payload.dataProtection = dataProtection ?? termsAndConditions;
      payload.marketingPurpose = marketingPurpose ?? false;
    }
    const response = await axios.post('/auth/google-one-tap', payload);
    return response;
  } catch (error) {
    console.error('Error authenticating Google One Tap:', error);
    throw error;
  }
};

export const checkSiteMaintenanceCall = async () => {
  const response = await fetch("/api/maintenance", { cache: 'no-store' });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const err = Object.assign(new Error(data?.message || 'Maintenance check failed'), {
      response: { data, status: response.status },
    });
    throw err;
  }
  return response;
};